import styled from 'styled-components';

const LogoMobile = styled.img`
	width: ${({ theme }) => theme.widthLogoMobile};
`;

export default LogoMobile;
